// extracted by mini-css-extract-plugin
module.exports = {"admin-layout":"AdminLayout_admin-layout__13HiS","admin-content":"AdminLayout_admin-content__iMAaq","menu-collapsed":"AdminLayout_menu-collapsed__JjFB7"};